import { computed, defineComponent, getCurrentInstance, toRefs } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentAutomationRequestCardHeader",
  props: {
    group: {
      type: String,
      required: true
    },
    groupKey: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const internalInstance = getCurrentInstance();
    const {
      group,
      groupKey
    } = toRefs(props);
    const subtitle = computed(() => internalInstance == null ? void 0 : internalInstance.proxy.$t(`automations.documentLevel.requestedBasedOnGroup.${groupKey.value}`));
    return {
      title: group,
      subtitle
    };
  }
});